import 'CssFolder/user.scss'
import { messageComponent } from '../../components/message/message.component';
import ViewBase from '../view-base.view';
import SurveyCategoryMasterView from './survey-category-master.view';
import SurveyRegisterView from './survey-register.view';
import SurveyResponseView from './survey-response.view';
import SurveySearchView from './survey-search.view';


export default function SurveyView() {
  ViewBase.call(this);

  const SCREEN_SURVEY_SEARCH = 1;
  const SCREEN_SURVEY_REGISTER = 2;
  const SCREEN_SURVEY_RESPONSE = 3;

  const SCREENS = {
    [SCREEN_SURVEY_SEARCH]: SurveySearchView,
    [SCREEN_SURVEY_REGISTER]: SurveyRegisterView,
    [SCREEN_SURVEY_RESPONSE]: SurveyResponseView
  };

  const changeScreen = (screenId) => {
    this.state.currentScreen = SCREENS[screenId];
    this.state.currentScreenNumber = screenId;
  };

  const surveyViewState = {
    filterParams: {},
    selectedSortIndex: 0,
    surveyList: [],
    listDirty: true,
    updateObject(newObj) {
      let objToEdit = this.surveyList.find((element) => element.surveyId === newObj.surveyId);
      Object.assign(objToEdit, newObj);
    },
    saveState(surveyList, filterParams) {
      this.surveyList = _.cloneDeep(surveyList);
      this.filterParams = _.cloneDeep(filterParams);
      this.listDirty = false;
    },
    clearState() {
      this.filterParams = {};
      this.selectedSortOption = {};
      this.surveyList = [],
        this.listDirty = true;
    }
  };

  let isMsgOpen = false;
  let showMsg = "";
  let msgTitle = "";
  let isListPage = true;
  let selectedSurveyTitle = "";
  let selectedSurveyId = "";
  let selectedSurveyIdString = "";
  let isNew = false;
  let showTabs = true;

  let tabButton = (txt, screenId, icon = undefined) => {
    let activeClass = screenId === this.state.currentScreenNumber ? "btn-primary" : "btn-outline-primary";
    return m("a.btn[role=tablist]",
      {
        class: activeClass,
        onclick: () => {
          changeScreen(screenId);
        }
      },
      icon !== undefined && icon,
      txt
    )
  }

  return {
    oninit: (vnode) => {
      this.initState(vnode.state);
      changeScreen(SCREEN_SURVEY_SEARCH);
    },
    view: (vnode) => {
      return [
        isListPage &&
        m('.row',
          m(".col-md-12",
            showTabs &&
            m(".d-flex.gap-3",
              tabButton(this.getText("LT00000001", "Search"), SCREEN_SURVEY_SEARCH, m('i.bi.bi-search')),
              tabButton(this.getText("LT00000017", "Register"), SCREEN_SURVEY_REGISTER, m('i.bi.bi-plus-lg')),
            ),
            showTabs && m('hr.my-3', { style: 'background-color: var(--is-link-blue);' }),
            m("div",
              m(this.state.currentScreen, {
                surveyViewState: surveyViewState,
                surveyId: selectedSurveyId,
                surveyIdString: selectedSurveyIdString,
                surveyTitle: selectedSurveyTitle,
                onSaved: (result) => {
                  showTabs = true;
                  if (result.transResult && result.transResult.length > 0) {
                    isMsgOpen = true;
                    showMsg = result.transResult[0].message;
                    msgTitle = result.transResult[0].transStatus;
                  }
                  changeScreen(SCREEN_SURVEY_SEARCH);
                  setTimeout(() => {
                    changeScreen(SCREEN_SURVEY_REGISTER);
                  }, 100);
                },
                onOpenQuestionList: (surveyId) => {
                  isNew = true;
                  selectedSurveyId = surveyId;
                  isListPage = false;
                },
                onManaged: (surveyId, surveyIdString) => {
                  selectedSurveyId = surveyId;
                  selectedSurveyIdString = surveyIdString;
                  isListPage = false;
                },
                onUpdateClick: (surveyId, surveyIdString) => {
                  showTabs = false;
                  selectedSurveyId = surveyId;
                  selectedSurveyIdString = surveyIdString;
                  changeScreen(SCREEN_SURVEY_REGISTER);
                },
                onResponseClick: (surveyId, surveyTitle) => {
                  showTabs = false;
                  selectedSurveyId = surveyId;
                  selectedSurveyTitle = surveyTitle;
                  changeScreen(SCREEN_SURVEY_RESPONSE);
                },
                onGoBack: () => {
                  showTabs = true;
                  selectedSurveyId = "";
                  changeScreen(SCREEN_SURVEY_SEARCH);
                }
              }),

            ),
          )
        ),
        !isListPage &&
        m(SurveyCategoryMasterView, {
          isNew: isNew,
          surveyId: selectedSurveyId,
          surveyIdString: selectedSurveyIdString,
          surveyViewState: surveyViewState,
          onSaveComplete: () => {
            isListPage = true;
            showTabs = true;
            selectedSurveyId = "";
            changeScreen(SCREEN_SURVEY_SEARCH);
          }
        }),
        m(messageComponent, { isOpen: isMsgOpen, message: showMsg, title: msgTitle, onClosed: () => { isMsgOpen = false; } }),
        this.getBaseViews()
      ];
    }
  }
}
